import { render } from "./Photos.vue?vue&type=template&id=64292d70&scoped=true"
import script from "./Photos.vue?vue&type=script&lang=js"
export * from "./Photos.vue?vue&type=script&lang=js"

import "./Photos.vue?vue&type=style&index=0&id=64292d70&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64292d70"]])

export default __exports__